import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { useMediaQuery } from 'react-responsive';
import LogoWom from '../../../images/logowom.svg';
import NewsWrapper from '../../News/NewsWrapper';
import Womer from '../../../images/womer.svg';
import SideNavMobile from '../../Menu/SideNavMobile';

import { SEGMENT_PREPAID } from '../../../shared/constants';
import ChannelSwitch from '../../ChannelSwitch';
import useUser from '../../../hooks/useUser';

import {
  MainNavStyled,
  SecondNavStyled,
  NavItemStyled,
  NavLinkStyled,
} from './styles/NavStyled';
import Header from '../../Menu/Header/Header';
import HelpHeader from '../../Help/HelpHeader/HelpHeader';

const Nav = () => {
  const [segment, setSegment] = useState('');
  const user = useUser();

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  useEffect(() => {
    setSegment(user ? user.plan.segment : '');
  }, []);

  const InfoHeader = (
    <MainNavStyled className="nav_row">
      <button
        type="button"
        className="main_nav-logo-container"
        onClick={() => {
          navigate('/home');
        }}
      >
        <img className="logo-nav" src={LogoWom} alt="logo WOM" />
        <div className="user-details">
          <img src={Womer} alt="usuario womer" />
          <div className="details-text">
            <h2>
              {[SEGMENT_PREPAID].includes(segment.toUpperCase())
                ? 'Prepago'
                : user.plan.name}
            </h2>
            <p>{`+${user.plan.number}`}</p>
          </div>
        </div>
      </button>
      <SecondNavStyled>
        <NavItemStyled hideOnMobile>
          <NavLinkStyled
            onClick={() => {
              navigate('/home');
            }}
          >
            Ir al Inicio
          </NavLinkStyled>
        </NavItemStyled>
        <NavItemStyled>
          <NewsWrapper />
        </NavItemStyled>
        <NavItemStyled>
          <ChannelSwitch />
        </NavItemStyled>
        <NavItemStyled>
          <HelpHeader />
        </NavItemStyled>
      </SecondNavStyled>
    </MainNavStyled>
  );

  if (!user) return null;

  return (
    <>
      {InfoHeader}
      {isMobileDevice && <Header />}
      <SideNavMobile />
    </>
  );
};

export default Nav;
